var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m25.52,13.44H7.77L15.5,3.99c.54-.67.45-1.65-.22-2.19-.67-.54-1.65-.45-2.19.22L3.27,14.01c-.47.57-.47,1.4,0,1.97l9.81,12c.31.38.76.57,1.21.57.35,0,.7-.12.99-.35.67-.54.77-1.53.22-2.19l-7.73-9.45h17.75c.86,0,1.56-.7,1.56-1.56s-.7-1.56-1.56-1.56Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrow);
export default __webpack_public_path__ + "static/media/backArrow.d4a9ecacb870da54c6fbf06c367e5989.svg";
export { ForwardRef as ReactComponent };